module.exports = __webpack_public_path__ + "img/main_2.e0d8f8b5.jpg";